/**
 * Created by Wolfgang Teufl on 08.03.2018.
 */
var store = require('frontend-controller/lib/store');

module.exports = {
	events: {
		privacyCloseButton: {
			type: 'click',
			selector: 'div.closeBut',
			action: function(event){
				event.data.component.savePrivacySettings(true, false);
			}
		},
		privacyAcceptButton: {
			type: 'click',
			selector: 'button[data-type=accept]',
			action: function(event){
				event.data.component.savePrivacySettings(true, false);
			}
		},
		privacyDenyButton: {
			type: 'click',
			selector: 'button[data-type=deny]',
			action: function(event){
				event.data.component.savePrivacySettings(false, false);
			}
		}
	},
	methods: {
		open: function(){
			// show overlay
			this.$.show();
		},

		savePrivacySettings: function (accepted, showConfirmation) {
			// set decision of user in store
			var updatedStorage = store.set({
				session: {
					data: {
						cookiePolicy: {
							acceptTracking: Boolean(accepted)
						}
					}
				}
			});
			// store.updateSessionData({
			// 	session: {
			// 		data: {
			// 			cookiePolicy: updatedStorage.session.data.cookiePolicy
			// 		}
			// 	}
			// }, undefined, updatedStorage.app.webService.config.externalSessionUpdateURI);

			// tell master to updated policy
			this.closest('base_master_master', function(masterComponent){
				masterComponent.trackingPolicyChanged();
			});

			// hide overlay
			this.$.hide();

			// is called by impress
			if (showConfirmation === true) {
				// show confirmation window on "deny"

				var $overlay = this.$.parent().find('.templates_privacyOverlay_privacyOverlayConfirmation');
				if (accepted === false) {
					$overlay.find('.accepted').hide();
					$overlay.find('.denied').show();
				} else {
					$overlay.find('.accepted').show();
					$overlay.find('.denied').hide();
				}
				$overlay.show();

			}
		}
	}
};